/**
=========================================================
* Otis Admin PRO - v2.0.1
=========================================================

* Product Page: https://material-ui.com/store/items/otis-admin-pro-material-dashboard-react/
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Fade from "@mui/material/Fade";

// Otis Admin PRO React base styles
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";
import borders from "assets/theme/base/borders";

// Otis Admin PRO React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { black, light } = colors;
const { size, fontWeightRegular } = typography;
const { borderRadius } = borders;

export default {
  defaultProps: {
    arrow: true,
    TransitionComponent: Fade,
  },

  styleOverrides: {
    tooltip: {
      maxWidth: pxToRem(220),
      backgroundColor: "rgba(30, 42, 62, 0.94)",
      color: light.main,
      fontSize: size.xs,
      fontWeight: fontWeightRegular,
      textAlign: "center",
      borderRadius: borderRadius.lg,
      padding: `${pxToRem(6)} ${pxToRem(12)} ${pxToRem(6)}`,
      backdropFilter: "blur(4px)",
      boxShadow: "0 4px 16px rgba(0,0,0,0.18)",
    },

    arrow: {
      color: "rgba(30, 42, 62, 0.94)",
    },
  },
};
